import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Link } from "react-router-dom";

const GraphicDetailPage = () => {
  return (
    <Fragment>
      <main className="page_content about-page ">
        <PageTitle pageTitle={"Graphic Designer"} />
        <div className="pt-175 pb-80 ">
            <div className="container">
                <h4 className="mb-4">Job Description</h4>
                <p>We are seeking a creative, detail-oriented Graphic & Web Designer to join our team on a full-time, office-based basis. You’ll be responsible for designing posters, flyers, digital content, and website layouts that support our growing travel and events business.</p>
                <p>This role is perfect for someone with strong design skills and a sharp eye for detail who enjoys working in a fast-paced, collaborative environment.</p>
                
                <h4 className="mb-4">Key Responsibilities:</h4>
                <ul>
                    <li>Design high-quality promotional materials (posters, flyers, brochures)</li>
                    <li>Create layouts and visual assets for websites and landing pages</li>
                    <li>Collaborate with the marketing and development teams to bring campaigns to life</li>
                    <li>Ensure consistency across all brand visuals (print and digital)</li>
                    <li>Proof all designs for spelling, grammar, and layout errors before publishing</li>
                    <li>Deliver files in formats suitable for web and print</li>
                </ul>

                <h4 className="mb-4">Requirements:</h4>
                <ul>
                    <li>Proven experience in graphic and web design (portfolio required)</li>
                    <li>Skilled in Adobe Creative Suite (Photoshop, Illustrator, InDesign) and Figma or similar tools</li>
                    <li>Strong understanding of layout, typography, and visual hierarchy</li>
                    <li>Knowledge of basic UX/UI principles for web design</li>
                    <li>Attention to detail and ability to spot content inconsistencies</li>
                    <li>Strong communication and teamwork skills</li>
                </ul>

                 <h4 className="mb-4">Preferred Skills:</h4>
                <ul>
                    <li>Experience in travel, events, or religious sector design</li>
                    <li>Basic understanding of HTML/CSS</li>
                    <li>Awareness of Islamic event themes (e.g., Umrah, Hajj) is a plus</li>
                </ul>

                <h4 className="mb-4">What We Offer:</h4>
                <ul>
                    <li>Full-time, office-based position with room to grow</li>
                    <li>Opportunity to have creative input and take ownership of projects</li>
                    <li>Supportive, mission-driven work culture</li>
                    <li>Involvement in meaningful, community-focused campaigns</li>
                </ul>

                <p className="mt-5">Send your updated CV and a short introduction to: <strong>hr@apeitsolutions.com</strong></p>
                {/* <Link to='/seo-detail' class="btn btn-primary mt-5">
                <span class="btn_label" data-text="Apply Now"> Apply Now </span>
                <span class="btn_icon">
                    <i class="fa-solid fa-arrow-up-right"></i>
                </span>
            </Link> */}
            </div>
        </div>
      </main>
      <Scrollbar />
    </Fragment>
  );
};

export default GraphicDetailPage;
